import React from 'react'
import { AllIntegrations } from '../modules/companies';

export const AccountsPage = () => {
    return (
        <AllIntegrations />
    )
};
